import { Component, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { FormControl, FormGroup } from "@angular/forms";
import { DatePipe } from "@angular/common";
import { ChartType } from "../../dashboard/dashboard.model";
import { DashboardService } from "../../../services/dashboard.service";
import { AlertService } from "ngx-alerts";
import { PageEvent } from "@angular/material/paginator";
import { finalize } from "rxjs/operators";

@Component({
  selector: "app-driver-risk-analysis",
  templateUrl: "./driver-risk-analysis.component.html",
  styleUrls: ["./driver-risk-analysis.component.scss"],
})
export class DriverRiskAnalysisComponent implements OnInit {
  customerName: string = "";
  customerId: any;
  title: any = "Performance analysis of: ";
  riskAnalysisDateRange: FormGroup = new FormGroup({
    start: new FormControl(),
    end: new FormControl(),
  });
  search: any = {
    periodFrom: undefined,
    periodTo: undefined,
  };
  tripAnalysis: ChartType;
  kmsAnalysis: ChartType;
  riskAnalysisResponse: any;
  userTrips: any[] = [];
  tripSearch = {
    size: 5,
    page: 0,
    isFleetView: false,
    periodFrom: "",
    periodTo: "",
    returnCo2Emission: true,
  };

  totalRecords = 0;
  pageEvent: PageEvent;
  today = new Date();

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private datePipe: DatePipe,
    private dashboardService: DashboardService,
    private alertService: AlertService
  ) {}

  ngOnInit(): void {
    this.route.queryParams.subscribe((res: any) => {
      this.customerName = res["customerName"];
      this.title += this.customerName;
    });
    this.customerId = this.route.snapshot.params.id;
    this.getDriverRiskAnalysis();
    this.getTrips();
  }

  private getTrips() {
    this.dashboardService
      .getUserTrips(this.customerId, this.tripSearch)
      .subscribe(
        (res: any) => {
          this.totalRecords = res.totalRecords;
          this.userTrips = res.userTrips;
          this.userTrips.forEach((trip) => {
            trip.safetyScore = (trip.safeKm / trip.tripDistance) * 100;
          });
        },
        (error1) => {
          console.error(error1);
          this.alertService.danger(error1.message ? error1.message : error1);
        }
      );
  }

  onDateRangeChange() {
    if (
      this.riskAnalysisDateRange.value.start &&
      this.riskAnalysisDateRange.value.end
    ) {
      this.search.periodFrom = this.datePipe.transform(
        new Date(this.riskAnalysisDateRange.value.start),
        "yyyy-MM-dd"
      );
      this.search.periodTo = this.datePipe.transform(
        new Date(this.riskAnalysisDateRange.value.end),
        "yyyy-MM-dd"
      );
      this.tripSearch.periodFrom = this.search.periodFrom;
      this.tripSearch.periodTo = this.search.periodTo;
      this.getDriverRiskAnalysis();
      this.getTrips();
    }
  }

  onClearDateRangeClick() {
    this.riskAnalysisDateRange.get("start").setValue(undefined);
    this.riskAnalysisDateRange.get("end").setValue(undefined);
    this.search.periodFrom = undefined;
    this.search.periodTo = undefined;
    this.getDriverRiskAnalysis();
  }

  private getDriverRiskAnalysis() {
    this.dashboardService
      .getDriverRiskAnalysis(this.customerId, this.search)
      .subscribe(
        (res: any) => {
          this.riskAnalysisResponse = res.userRiskAnalysis;
          //limit to 2 decimals
          this.riskAnalysisResponse.safetyScore =
            Math.round(this.riskAnalysisResponse.safetyScore * 100) / 100;
          this.riskAnalysisResponse.totalSafeTripsPercentage =
            (this.riskAnalysisResponse.totalSafeKm /
              (this.riskAnalysisResponse.totalSafeKm +
                this.riskAnalysisResponse.totalUnsafeKm)) *
            100;
          this.processChartData(this.riskAnalysisResponse);
        },
        (error) => {
          console.error(error);
          this.alertService.danger(error.message ? error.message : error);
        }
      );
  }

  private processChartData(res: any) {
    this.tripAnalysis = {
      series: [res.totalSafeTrips, res.totalUnsafeTrips, res.criticalTrips],
      chart: {
        height: 180,
        type: "donut",
      },
      labels: ["Safe Trips", "Unsafe Trips", "Critical Trips"],
      plotOptions: {
        pie: {
          donut: {
            size: "75%",
          },
        },
      },
      dataLabels: {
        enabled: false,
      },
      legend: {
        show: false,
      },
      colors: ["#1cbb8c", "#ff8c00", "#ff0000"],
    };

    this.kmsAnalysis = {
      series: [
        {
          name: "",
          data: [res.totalSafeKm, res.totalUnsafeKm],
        },
      ],
      chart: {
        height: 180,
        type: "bar",
      },
      labels: ["Safe Kms", "Unsafe Kms"],
      plotOptions: {
        bar: {
          borderRadius: 4,
          barHeight: "20%",
          horizontal: true,
          distributed: true,
        },
      },
      dataLabels: {
        enabled: false,
        style: {
          colors: ["#1cbb8c", "#ff8c00"],
        },
      },
      legend: {
        show: false,
      },
      colors: ["#1cbb8c", "#ff8c00"],
    };
  }

  processLocationName(startLocationName: any) {
    if (startLocationName) {
      const processedName = startLocationName.split(",").slice(0, 4).join(",");
      if (processedName.length > 20) {
        return processedName.slice(0, 20) + "...";
      } else {
        return processedName;
      }
    } else {
      return "-";
    }
  }
  getServerData(ev: PageEvent) {
    this.tripSearch.page = ev.pageIndex;
    this.tripSearch.size = ev.pageSize;
    this.getTrips();
    return ev;
  }
}
